import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Stack,
  Typography,
} from "@mui/material";

const BatteryNotDetectedDialog = ({
  open,
  doorNumber,
  batteryId,
  isDetected,
  batterySelect,
  isLoading,
  submitDisabled,
  submitError,
  onWait,
  onSubmit,
}) => (
  <Dialog
    open={open}
    maxWidth="xs"
    fullWidth
    disableEscapeKeyDown
    disableEnforceFocus
  >
    <DialogTitle>In-battery not detected</DialogTitle>
    <DialogContent>
      <Stack gap={2}>
        <Typography variant="body2">
          The station is still waiting to detect the battery inserted in{" "}
          <b>Door {doorNumber}</b>. You can wait for the detection, or submit
          the swap now with the battery ID below.
        </Typography>

        <Box>
          <Typography variant="caption" color="text.secondary">
            In Battery ID
          </Typography>
          <Typography variant="body1" sx={{ fontWeight: 600 }}>
            {batteryId || "-"}
          </Typography>
          <Typography
            variant="caption"
            sx={{ color: isDetected ? "#079B27" : "#F32424" }}
          >
            {isDetected ? "Auto detected" : "Entered manually"}
          </Typography>
        </Box>

        {batterySelect && (
          <Box
            sx={{
              opacity: isDetected ? 0.5 : 1,
              pointerEvents: isDetected ? "none" : "auto",
            }}
          >
            <Typography variant="caption" color="text.secondary">
              Change in battery if required, otherwise leave it as is
            </Typography>
            {batterySelect}
          </Box>
        )}

        {submitError && (
          <Typography variant="body2" color="error">
            {submitError}
          </Typography>
        )}
      </Stack>
    </DialogContent>
    <DialogActions sx={{ px: 3, pb: 2 }}>
      <Button onClick={onWait} disabled={isLoading}>
        Wait
      </Button>
      <Button
        variant="contained"
        onClick={onSubmit}
        disabled={isLoading || submitDisabled}
      >
        Submit
      </Button>
    </DialogActions>
  </Dialog>
);

export default BatteryNotDetectedDialog;